<template>
  <div :class="$style.wrap">
    <BaseIcon name="search" :class="$style.icon" />
    <input
      :placeholder="$t('searchPlaceholder')"
      type="text"
      :class="$style.input"
      v-on="inputListeners"
      v-bind="$attrs"
      :value="value"
      ref="input"
      @keyup.esc="$emit('clear')"
    >
    <BaseIcon
      v-if="value"
      custom name="close"
      :class="$style.clear"
      @click="$emit('clear')"
    />
  </div>
</template>

<script>
export default {
  name: 'search-input',
  props: {
    value: {}
  },
  computed: {
    inputListeners () {
      return Object.assign({},
        this.$listeners,
        {
          input: event => {
            this.$emit('input', event.target.value)
          }
        }
      )
    }
  },
  methods: {
    focus () {
      this.$refs.input.focus()
    }
  }
}
</script>

<style lang="scss" module>
.wrap {
  position: relative;
}
.icon {
  position: absolute;
  top: 10px;
  left: 10px;
  color: $text-light;
  font-size: 18px;
}
.input {
  border: none;
  width: 100%;
  height: 40px;
  line-height: 40px;
  border-radius: 4px;
  background-color: $main-bg-dark;
  padding-left: 36px;
}
.clear {
  cursor: pointer;
  font-size: 14px;
  position: absolute;
  right: 8px;
  top: 14px;
  color: $text-dark;
}
</style>
